// extracted by mini-css-extract-plugin
module.exports = {"thankYouScreen":"styles_thankYouScreen__3N90q","img":"styles_img__3fgki","title":"styles_title__2wCAx","subtitle":"styles_subtitle__1oQzp"};